import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "providerIcon",
  "use": "providerIcon-usage",
  "viewBox": "0 0 16.59 19.14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.59 19.14\" id=\"providerIcon\"><title>服务商</title><path d=\"M16.57 17.74a8.42 8.42 0 0 0-5.08-6.31.48.48 0 0 1-.08-.85 5.75 5.75 0 1 0-6.25 0 .48.48 0 0 1-.08.85 8.42 8.42 0 0 0-5.06 6.31 1.2 1.2 0 0 0 1 1.39l.19.01h14.17a1.2 1.2 0 0 0 1.19-1.4zm-7-1.79l-1.09 1.62a.2.2 0 0 1-.27.05l-.05-.05-1.12-1.63a.38.38 0 0 1 0-.32l1.09-3.64h-.2a.14.14 0 0 1-.14-.09l-.15-.56a.12.12 0 0 1 .02-.19h1.22a.12.12 0 0 1 .11.17l-.15.56a.14.14 0 0 1-.14.09h-.2l1.09 3.64a.37.37 0 0 1 0 .32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/providerIcon.svg
// module id = 2n8G
// module chunks = 6